import { observable } from 'mobx';

export class Tag {
  @observable public id: number;
  @observable public name: string;
  @observable public color: string;

  public static getIdFromSlug(slug: string): number {
    return parseInt(slug, 10);
  }

  public static deserializeTagsString(tagsString: string): Array<string> {
    const replacements = tagsString.split(',,');

    return replacements.reduce(
      (replaced: Array<string>, replacementPart: string) => {
        const parts = replacementPart.split(',');

        if (replaced.length > 0) {
          replaced.push(replaced.pop() + ',' + parts.shift());
        }

        return replaced.concat(...parts);
      },
      []
    );
  }

  public static serializeTagsString(tags: Array<Tag>): string {
    return tags.map((tag: Tag) => tag.name.replace(/\,/g, ',,')).join(',');
  }

  constructor(id: number, name: string, color: string) {
    this.id = id;
    this.name = name;
    this.color = color;
  }
}

export default Tag;



// WEBPACK FOOTER //
// ./src/app/models/Tag.ts